/****************************************************************
 * WARNING THIS FILE IS AUTOGENERATED AND SHOULD NOT BE MODIFIED *
 ****************************************************************/
import * as React from "react"
import Svg from "@oui/system/Svg"
type DefaultProps = typeof defaultProps
type SvgProps = React.ComponentPropsWithoutRef<typeof Svg>
type Props = DefaultProps &
  Omit<SvgProps, "fill" | "height" | "stroke" | "viewBox" | "width">
const defaultProps = {
  label: "File Edit",
  size: 20
}

const SvgFileEdit = ({ size, ...props }: Props) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="currentcolor"
    stroke="currentcolor"
    {...props}
  >
    <path
      fill="none"
      d="M18.65 1.68c-.24-.23-.541-.35-.84-.35-.311 0-.601.12-.83.35L8.92 9.76 8 12.33l2.55-.92 8.101-8.07c.469-.47.469-1.19-.001-1.66h0z"
    />
    <path fill="none" d="M16.5 8.482V18.5h-13v-17h10.711" />
  </Svg>
)

SvgFileEdit.defaultProps = defaultProps
export default SvgFileEdit
